import { SearchTarget } from "../enums/SearchTarget";

export class DQOIDisplayItem {
    target: string;
    customer: string;
    location: string;
    number: string;
    id: any = null;
}